/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */

import React from 'react';
import VehicleDetailsCard from "./VehicleDetailsCard";
import DocumentStatusThree from "../../../../../components/DocumentStatusThree";
import {CreateToExternalVehicle,SetToExternalVehicle} from "../../../../../reduxToolkit/Contractor/ContractorApi";
import {DownloadProviderImage} from "../../../../../reduxToolkit/Providers/providersApi";
import {TABLES} from "../../../../../Apis/Tables";
import {USER_TYPE_DOCUMENT} from "../../../../../enums/userTypeEnum";
import DeleteModal from "../../../../Modals/DeleteModal";
import {useTranslation} from "react-i18next";

const VehicleDetailsBody = (props) => {
    const {t} = useTranslation();
    const {elementDetails, disabled, showBtnDelete = false, deleteVehicleShow, setDeleteVehicleShow, deleteSelectedVehicles=(e) => {}}  = props;

    return (
        <>
            <div className='row mt-5 mb-5'>
                <VehicleDetailsCard elementDetails={elementDetails}/>

                <div className='col-8 mb-2'>
                    <div className='w-100 border-card h-100'>
                        <DocumentStatusThree
                            disabled={disabled}
                            dataTable={elementDetails?.documents}
                            userType={TABLES.CONTRACTOR_VEHICLE}
                            setDocValue={SetToExternalVehicle}
                            createDocValue={CreateToExternalVehicle}
                            downloadImg={DownloadProviderImage}
                            optionDownload={USER_TYPE_DOCUMENT.CONTRACTOR_VEHICLE_DOCUMENT}
                            showBtnDelete={showBtnDelete}
                        />
                    </div>
                </div>
            </div>

            <DeleteModal
                title_modal={t('delete')}
                show={deleteVehicleShow}
                onHide={() => setDeleteVehicleShow(false)}
                element_modal={t('vehicles')}
                data={[elementDetails?.vehicle?.id]}
                onClickFn={() => deleteSelectedVehicles([elementDetails?.vehicle?.id])}
            />
        </>
    );
};

export default VehicleDetailsBody;
